import { render, staticRenderFns } from "./AmwayKZ.vue?vue&type=template&id=25a677cb&"
import script from "./AmwayKZ.vue?vue&type=script&lang=js&"
export * from "./AmwayKZ.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports